import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../components/Icon';
import { Subscription } from '../../model/Subscription';
import { NumsiModal } from '../../components/NumsiModal';
import { formatMsisdn } from '../../utils/helpers';

interface Props {
	subscriptions: Subscription[];
}

const NumsiContainer = styled.div`
	width: 100%;
	margin: auto;
	margin-top: 2em;
	border: 2px solid red;
	overflow: auto;
	padding: 1.818em;
	padding-top: 1.477em;
	padding-bottom: 1.364em;
	.title {
		color: red;
		margin-top: 0.966em;
		margin-left: 0.909em;
	}
	.icon-container {
		float: left;
	}
`;

const ListContainer = styled.div`
	span {
		margin-right: 0.909em;
	}
	button {
		width: 12.5em;
		height: 2.273em;
		border: 2px solid red;
		border-radius: 6px;
		color: red;
	}
	.numsi-row {
		margin-top: 0.909em;
		float: right;
		clear: both;
	}
	@media only screen and (max-width: 600px) {
		.left {
			display: block;
			width: 100%;
		}
		button {
			width; 10em;
		}
	}
`;

export const NumsiList: React.FC<Props> = (props: Props) => {
	const [active, setActive] = useState<Subscription | undefined>(undefined);
	return (
		<div>
			{props.subscriptions.length > 0 && (
				<NumsiContainer>
					<div className={'icon-container'}>
						<Icon name={'small--alert'} />
					</div>
					<span className={'title'}>Numeronsiirto epäonnistui tai odottaa lisätietoja. Tarkista seuraavien liittymien tiedot</span>
					<ListContainer>
						{props.subscriptions.map((subscription: Subscription, index: number) => (
							<div key={index} className={'numsi-row'}>
								<span className={'left'}>{`${subscription.name} [${formatMsisdn(subscription.msisdn)}]`}</span>
								<button onClick={() => setActive(subscription)}>Tarkista liittymän tiedot</button>
							</div>
						))}
					</ListContainer>
				</NumsiContainer>
			)}
			{active !== undefined && <NumsiModal subscription={active} onClose={() => setActive(undefined)} />}
		</div>
	);
};
